import day from "dayjs";

export const toUnixDate = (data = {}, key) =>
  data[key] ? { [key]: data[key].unix() } : {};

export const fromUnixDate = (data = {}, key) =>
  data[key] ? { [key]: day.unix(data[key]) } : {};
